module.exports = __webpack_public_path__ + "img/add-to-list.0690158b.svg";